module.exports = {"views.headerAndSidebarLayout.sidebar.navList.item1":"Abonnements","views.headerAndSidebarLayout.sidebar.navList.item2":"Paramètres","views.headerAndSidebarLayout.sidebar.navList.item3":"Politique des données","views.headerAndSidebarLayout.sidebar.description":"Besoin d'aide ? Veuillez nous contacter à l'adresse suivante ","views.headerAndSidebarLayout.sidebar.customerCare":"service clientèle","views.headerAndSidebarLayout.header.signOut.text":"Déconnexion","views.headerAndSidebarLayout.header.contactUs.text":"Contactez-nous"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr/views/HeaderAndSidebarLayout.json
// module id = 780
// module chunks = 0